__turbopack_context__.v({
  "accordion-details": "AccordionDetails-module-scss-module__f3Dy-a__accordion-details",
});
